<div class="date-filter"></div>
<kendo-tabstrip>
  <kendo-tabstrip-tab
    #customer_analytics_securityoperationscenter
    title="Security Operations Center"
    [selected]="!selectEdr()"
  >
    <ng-template kendoTabContent>
      <div class="content">
        <app-soc-v2></app-soc-v2>
      </div>
    </ng-template>
  </kendo-tabstrip-tab>

  @if (showEdrTab()) {
    <kendo-tabstrip-tab
      #customer_analytics_endpointdetectionandresponse
      title="Endpoint Detection and Response"
      [selected]="selectEdr()"
    >
      <ng-template kendoTabContent>
        <div class="content">
          <app-edr></app-edr>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
  }
  @if (showVssTab()) {
    <kendo-tabstrip-tab
      #customer_analytics_vulnerabilityscanservice
      title="Vulnerability Scanning Service"
      [selected]="false"
    >
      <ng-template kendoTabContent>
        <div class="content">
          <app-vss></app-vss>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
  }
  @if (showEsTab()) {
    <kendo-tabstrip-tab
      #customer_analytics_endpointsecurity
      title="Email Security"
      [selected]="false"
    >
      <ng-template kendoTabContent>
        <div class="content">
          <app-es></app-es>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
  }

  <kendo-tabstrip-tab
    #customer_analytics_mitreattack
    title="MITRE ATT&CK"
    [selected]="false"
  >
    <ng-template kendoTabContent>
      <div class="content">
        <app-mitreattack></app-mitreattack>
      </div>
    </ng-template>
  </kendo-tabstrip-tab>
</kendo-tabstrip>
